import { RefObject } from 'react';
import { debounce } from 'lodash';

import { updateLocalStorage } from 'utils/browserCache';
import { INTERVAL_PING_SCROLL_POSITION } from './config';

import { ROUTES } from 'routes/constants';
import { CHATUI_WINDOW_PATH } from 'constants/global';
import { LOCAL_STORAGE_KEY } from 'constants/browserCache';
import { ACTIONS } from 'constants/hook';
import { ViewReducerActionType } from 'hooks/view/types';

export const listenerMainContentScroll = debounce(
  (
    initScrollPosRef: RefObject<number>,
    mainContentRef: RefObject<HTMLDivElement>,
    dispatchViewAction: (action: ViewReducerActionType) => void,
  ) => {
    const mainContentScrollHeight = mainContentRef?.current?.scrollTop;
    const hasChangedScrollPos = initScrollPosRef.current !== mainContentScrollHeight;

    // Leverage readily available global method instead of state hooks.
    // Event listener at invocation does not subscribe to these latest values.
    const isConnected = window[CHATUI_WINDOW_PATH].getIsConnected();
    const isChatPanel = window[CHATUI_WINDOW_PATH].getActivePanel() === ROUTES.CHAT;
    const viewState = window[CHATUI_WINDOW_PATH].getViewState();

    const nextViewState = { ...viewState };
    if (
      hasChangedScrollPos &&
      viewState.scrollToBottom.isCTAVisible &&
      !viewState.scrollToBottom.isLastMsgInView
    ) {
      nextViewState.scrollToBottom.isCTAVisible = false;
      dispatchViewAction({ type: ACTIONS.CHANGE, payload: nextViewState });
    }

    if (
      typeof mainContentScrollHeight === 'number' &&
      isConnected &&
      isChatPanel &&
      viewState.isPanelOpen
    ) {
      updateLocalStorage(LOCAL_STORAGE_KEY.CVNA_CHAT_UI_SCROLL_POS, mainContentScrollHeight);
    }
  },
  INTERVAL_PING_SCROLL_POSITION,
);
